import { useState, useCallback, useEffect } from "react";
import { productService } from "../services/productService";

export const useDealerProducts = (dealerId) => {
  const [dealerProducts, setDealerProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dealerName, setDealerName] = useState("Bayi"); // Bayi adını saklamak için

  const fetchDealerProducts = useCallback(async () => {
    if (!dealerId) {
      setDealerProducts([]);
      return; // dealerId yoksa işlem yapma
    }

    setLoading(true);
    setError(null);
    try {
      const productsData = await productService.getDealerProducts(dealerId);
      console.log(
        "useDealerProducts - Gelen Dealer Products Data:",
        productsData
      );
      setDealerProducts(productsData);
      // Bayi adını ilk üründen al (varsa)
      if (productsData && productsData.length > 0) {
        setDealerName(productsData[0]?.dealer_name || "Bayi");
      } else {
        // Bayi adını ayrıca çekmek gerekebilir veya ID'den bulmak?
        setDealerName(`Bayi #${dealerId}`);
      }
    } catch (err) {
      setError(err.message || "Bayi ürünleri getirilemedi");
      console.error("Bayi ürünleri getirme hatası:", err);
      setDealerProducts([]);
      setDealerName("Hata");
    } finally {
      setLoading(false);
    }
    // dealerId değiştiğinde tekrar çekmesi için bağımlılığa ekle
  }, [dealerId]);

  // dealerId değiştiğinde fetch işlemini tetikle
  useEffect(() => {
    fetchDealerProducts();
  }, [fetchDealerProducts]);

  return {
    dealerProducts,
    dealerName, // Bayi adını da döndür
    loading,
    error,
    refetchDealerProducts: fetchDealerProducts, // Yeniden yükleme için
  };
};
